import type { Quote } from '../../types/quotes/quote'
import type { RelatedInvoice } from '../../types/relatedInvoice'
import { isDepositInvoice } from './isDepositInvoice'

export const getQuoteDepositInvoiceDraft = (quote?: Quote): RelatedInvoice | undefined =>
  quote?.relatedInvoices?.find(
    (relatedInvoice) => !!relatedInvoice.invoiceDraftId && isDepositInvoice(relatedInvoice.billingStage),
  )
